import React, {useRef} from 'react'
import styled from '@emotion/styled'
import ToasterMessage from 'components/presentational/ToasterMessage'

import {Loader} from '@vio/atlas/Loader'
import useBodyScrollLock from '@vio/atlas/Overlay/useBodyScrollLock'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {useNetworkStatus} from '@vio/core/src/_web/utils/network/hooks/useNetworkStatus'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {isFlutterAppWebView} from '@vio/core/src/native'

const SpinnerWrapper = styled('div')`
  margin-block: 0;
  margin-inline: ${cssTheme.layout.spacing.s500} ${cssTheme.layout.spacing.s300};
`

const OfflineComponent = () => {
  const ref = useRef<HTMLDivElement>(null)

  useBodyScrollLock({ref})

  return (
    <div ref={ref}>
      <ToasterMessage>
        <Text>
          <FormattedMessageWrapper
            id="offlineMessage"
            defaultMessage="No internet connection. We are trying to reconnect…"
          />
        </Text>
        <SpinnerWrapper>
          <Loader />
        </SpinnerWrapper>
      </ToasterMessage>
    </div>
  )
}

const NetworkMonitor = () => {
  const isOnline = useNetworkStatus()
  if (isOnline || isFlutterAppWebView()) return null
  return <OfflineComponent />
}

export default NetworkMonitor
